import { Typography } from '@mui/material';
import { useRecordContext } from 'react-admin';
import { DEFAULT_TIMEZONE } from 'shared/mui/DatePicker/config/defaultValues';
import { formatInputInTz } from 'utils/date';
import { getTimezoneByName } from 'utils/getTimezoneByName';

type ActivePeriodFieldProps = {
  startSource?: string;
  endSource?: string;
  timezoneSource?: string;
};

export const ActivePeriodField: React.FC<ActivePeriodFieldProps> = ({
  startSource = 'startDateMilliseconds',
  endSource = 'endDateMilliseconds',
  timezoneSource = 'timeZone',
}) => {
  const record = useRecordContext();

  if (!record) {
    return null;
  }

  const recordStart = record[startSource];
  const recordEnd = record[endSource];
  const recordTz = record[timezoneSource] || DEFAULT_TIMEZONE;

  const formatDate = (seconds: number) =>
    formatInputInTz(seconds, { timezone: recordTz, format: 'dd.MM.yyyy, HH:mm' });

  const start = recordStart ? formatDate(recordStart) : 'Нет';
  const end = recordEnd ? formatDate(recordEnd) : 'Нет';
  const tz = getTimezoneByName(recordTz);

  return (
    <div>
      <Typography variant="body1">
        от: {start} <br /> до: {end}
      </Typography>
      <Typography color="textSecondary" variant="body1">
        {tz?.name} ({tz?.offset})
      </Typography>
    </div>
  );
};
